import './App.css';
import Navbar from './Components/NavBar';
import AboutDoctor from './Components/AboutDoctor';
import AboutOffice from './Components/AboutOffice';
import AboutServices from './Components/AboutServices';
import Contact from './Components/Contact';
import Footer from './Components/Footer';

function App() {
  return (
    <div className="App bg-white">
      <header className="sticky top-0 z-50">
        <Navbar />
      </header>
      <div id="aboutdoctor">
        <AboutDoctor />
      </div>
      <div id="aboutservices">
        <AboutServices />
      </div>
      <div id="aboutoffice">
        <AboutOffice />
      </div>
      <div id="contact">
        <Contact />
      </div>
      <Footer />
    </div>
  );
}

export default App;
